export default __webpack_public_path__ + "static/gallery9-3ec22f13aef702c1a5f3f9819ce30f65.png";